export enum ELanguage {
  EN = 'en',
  ES = 'es',
}
